'use client';

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Drawer, IconButton, List, Toolbar } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { Button } from '../Buttons';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import DropdownMenuMobile from '../DropdownMenu/DropdownMenuMobile';
import classes from './Navbar.module.scss';
import { ArrowDownIcon } from '@src/icons';
const Navbar = () => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [isRefferer, setIsRefferer] = useState(false);
  const pathname = usePathname();
  const isAppointmentPage = pathname.includes('/appointment/') || pathname.includes('/review/');
  const isScheduleAppointmentPage = pathname === '/';
  const handleMobileMenuClick = () => {
    setOpenMobileMenu(true);
  };
  const handleMenuClose = () => {
    setOpenMobileMenu(false);
  };
  useEffect(() => {
    const referrer = document.referrer;
    if (referrer.includes('physiciansimmediatecare.com')) {
      setIsRefferer(true);
    }
  }, []);
  if (isAppointmentPage) {
    return null;
  }
  const servicesItems = [{
    text: 'Urgent Care',
    link: 'https://www.wellnow.com/urgent-care'
  }, {
    text: 'Virtual Care',
    link: 'https://www.wellnow.com/virtual-care'
  }, {
    text: 'Occupational Medicine',
    link: 'https://www.wellnow.com/occupational-medicine'
  }, {
    text: 'Pediatrics',
    link: 'https://www.wellnow.com/urgent-care/pediatrics'
  }];
  const resourcesItems = [{
    text: 'About',
    link: 'https://www.wellnow.com/about'
  }, {
    text: 'Health & Wellness Resources',
    link: 'https://www.wellnow.com/resources'
  }, {
    text: 'FAQs',
    link: 'https://www.wellnow.com/faqs'
  }, {
    text: 'Your Visit',
    link: 'https://www.wellnow.com/your-visit'
  }, {
    text: 'Pay Bill',
    link: 'https://www.wellnow.com/billing'
  }];
  return <AppBar position="static" color="transparent" elevation={0} className={classes['app-bar']} sx={theme => ({
    backgroundColor: theme.palette.neutrals[50],
    [theme.breakpoints.up('lg')]: {
      backgroundColor: 'white'
    }
  })} data-sentry-element="AppBar" data-sentry-component="Navbar" data-sentry-source-file="Navbar.tsx">
			<Toolbar className={classes['toolbar']} data-sentry-element="Toolbar" data-sentry-source-file="Navbar.tsx">
				<Link href={!isScheduleAppointmentPage ? '/' : !isRefferer ? 'https://www.wellnow.com/' : 'https://physiciansimmediatecare.com/'} data-sentry-element="Link" data-sentry-source-file="Navbar.tsx">
					{!isRefferer ? <Image src={process.env.APP_PATH + `/wellnow-logo.svg`} alt="WellNow Urgent Care" width={152} height={40} /> : <Image src={process.env.APP_PATH + `/physiciansimmediatecare-logo.svg`} alt="WellNow Urgent Care" width={250} height={60} />}
				</Link>

				{isScheduleAppointmentPage && <>
						<Box className={classes['desktop-buttons']}>
							<DropdownMenu button={<Button variant="dark" endIcon={<ArrowDownIcon color="secondary" />} aria={{
            label: 'Services menu - click to expand'
          }}>
										Services
									</Button>} menuItems={servicesItems} />
							<DropdownMenu button={<Button variant="dark" endIcon={<ArrowDownIcon color="secondary" />} aria={{
            label: 'Resources menu - click to expand'
          }}>
										Resources
									</Button>} menuItems={resourcesItems} />
						</Box>

						<Box className={classes['mobile-buttons']}>
							<IconButton edge="end" className={classes['icon-button']} onClick={handleMobileMenuClick} aria-label="Open navigation menu">
								<MenuIcon />
							</IconButton>
						</Box>

						<Drawer anchor="right" open={openMobileMenu} onClose={handleMenuClose} variant="temporary" PaperProps={{
          sx: {
            width: '100%',
            height: '100%',
            backgroundColor: 'white'
          }
        }}>
							<IconButton onClick={handleMenuClose} className={classes['icon-menu-mobile']} aria-label="Close navigation menu">
								<CloseIcon />
							</IconButton>

							<List>
								<DropdownMenuMobile title="Services" items={servicesItems} />
								<DropdownMenuMobile title="Resources" items={resourcesItems} />
							</List>
						</Drawer>
					</>}
			</Toolbar>
		</AppBar>;
};
export default Navbar;